import { useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  useGetLogisticTaskStatusQuery
} from "../../../../entities/logistic/logisticTasks/redux/logisticTasks.api";

const DEFAULT_PULLING = {
  pollingInterval: 500,
};

const useLongPulling = ({ onStop }) => {
  const { logisticTaskId } = useParams();

  const { data } = useGetLogisticTaskStatusQuery({ id: logisticTaskId }, DEFAULT_PULLING);

  useEffect(() => {
    if (data === "SOLVED") {
      onStop();
    }
  }, [data]);
};

export default useLongPulling;
